window.addEventListener("load", function() {
    document.body.classList.add("loaded");
});

window.addEventListener('scroll', function() {
    const body = document.body;
    if (window.scrollY > 1400) { // 100px scroll pachhi class add
      body.classList.add('sticky-addtocart');
    } else {
      body.classList.remove('sticky-addtocart');
    }
});

jQuery( document ).ready(function($) {
    // Hero Slider
    $('.main-hero-section .hero-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
    });
    // Blogs Slider
    $('.blog .blogs-wrapper').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
        {
            breakpoint: 990,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
    });
    // Products Slider
    $('.main-slider-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.thumb-slider-images',
        prevArrow: `
            <button type="button" class="slick-prev" aria-label="Previous">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18 8.00111C18 7.8175 17.9271 7.64142 17.7972 7.51158C17.6674 7.38175 17.4913 7.30882 17.3077 7.30882L2.36335 7.31989L7.63218 2.03998C7.70014 1.97654 7.75462 1.90006 7.79237 1.8151C7.83013 1.73015 7.85039 1.63845 7.85194 1.5455C7.85349 1.45254 7.83631 1.36023 7.80141 1.27406C7.76651 1.18789 7.71461 1.10963 7.64881 1.04396C7.58301 0.97828 7.50465 0.926528 7.41842 0.891791C7.33218 0.857053 7.23983 0.84004 7.14688 0.841767C7.05393 0.843494 6.96228 0.863927 6.87739 0.901844C6.79251 0.939761 6.71613 0.994386 6.65281 1.06246L0.202463 7.52389C0.0728188 7.65369 0 7.82965 0 8.01311C0 8.19657 0.0728188 8.37253 0.202463 8.50233L6.65281 14.9638C6.78332 15.0899 6.95816 15.1598 7.13968 15.1583C7.3212 15.1568 7.49487 15.0841 7.62329 14.9558C7.75171 14.8275 7.8246 14.6539 7.82626 14.4724C7.82792 14.2909 7.75823 14.1159 7.63218 13.9853L2.3615 8.70448L17.3077 8.69433C17.3987 8.69433 17.4888 8.67639 17.5728 8.64154C17.6569 8.6067 17.7333 8.55562 17.7976 8.49124C17.8619 8.42685 17.9128 8.35042 17.9476 8.26632C17.9823 8.18223 18.0001 8.0921 18 8.00111Z" fill="#222222"/>
            </svg>
            </button>
        `,
        nextArrow: `
            <button type="button" class="slick-next" aria-label="Next">
            <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.319825 7.50116C0.319825 7.31388 0.394221 7.13427 0.526649 7.00184C0.659076 6.86941 0.838686 6.79502 1.02597 6.79502L16.2692 6.80631L10.895 1.42081C10.8257 1.35609 10.7701 1.27808 10.7316 1.19143C10.6931 1.10477 10.6724 1.01125 10.6708 0.916432C10.6693 0.821618 10.6868 0.727456 10.7224 0.639563C10.758 0.551671 10.8109 0.471848 10.878 0.404858C10.9452 0.337867 11.0251 0.285081 11.113 0.24965C11.201 0.214218 11.2952 0.196864 11.39 0.198625C11.4848 0.200387 11.5783 0.221228 11.6649 0.259903C11.7515 0.298579 11.8294 0.354296 11.894 0.423733L18.4733 7.01439C18.6055 7.14679 18.6798 7.32627 18.6798 7.51339C18.6798 7.70052 18.6055 7.88 18.4733 8.0124L11.894 14.6031C11.7608 14.7318 11.5825 14.803 11.3973 14.8015C11.2122 14.8 11.0351 14.7258 10.9041 14.5949C10.7731 14.4641 10.6987 14.287 10.697 14.1018C10.6953 13.9167 10.7664 13.7383 10.895 13.605L16.2711 8.21859L1.02597 8.20824C0.933155 8.20824 0.841254 8.18994 0.75552 8.1544C0.669785 8.11885 0.591899 8.06675 0.526315 8.00108C0.460732 7.93541 0.408737 7.85746 0.373306 7.77167C0.337874 7.68589 0.319701 7.59397 0.319825 7.50116Z" fill="#222222"/> 
            </svg>
            </button>
        `,
    });
    $('.thumb-slider-images').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.main-slider-images',
        centerMode: false,
        focusOnSelect: true,
        arrows: false
    });
    // Product Review Slider
    $(' .product-review-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: `
            <button type="button" class="slick-prev" aria-label="Previous">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18 8.00111C18 7.8175 17.9271 7.64142 17.7972 7.51158C17.6674 7.38175 17.4913 7.30882 17.3077 7.30882L2.36335 7.31989L7.63218 2.03998C7.70014 1.97654 7.75462 1.90006 7.79237 1.8151C7.83013 1.73015 7.85039 1.63845 7.85194 1.5455C7.85349 1.45254 7.83631 1.36023 7.80141 1.27406C7.76651 1.18789 7.71461 1.10963 7.64881 1.04396C7.58301 0.97828 7.50465 0.926528 7.41842 0.891791C7.33218 0.857053 7.23983 0.84004 7.14688 0.841767C7.05393 0.843494 6.96228 0.863927 6.87739 0.901844C6.79251 0.939761 6.71613 0.994386 6.65281 1.06246L0.202463 7.52389C0.0728188 7.65369 0 7.82965 0 8.01311C0 8.19657 0.0728188 8.37253 0.202463 8.50233L6.65281 14.9638C6.78332 15.0899 6.95816 15.1598 7.13968 15.1583C7.3212 15.1568 7.49487 15.0841 7.62329 14.9558C7.75171 14.8275 7.8246 14.6539 7.82626 14.4724C7.82792 14.2909 7.75823 14.1159 7.63218 13.9853L2.3615 8.70448L17.3077 8.69433C17.3987 8.69433 17.4888 8.67639 17.5728 8.64154C17.6569 8.6067 17.7333 8.55562 17.7976 8.49124C17.8619 8.42685 17.9128 8.35042 17.9476 8.26632C17.9823 8.18223 18.0001 8.0921 18 8.00111Z" fill="#222222"/>
            </svg>
            </button>
        `,
        nextArrow: `
            <button type="button" class="slick-next" aria-label="Next">
            <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.319825 7.50116C0.319825 7.31388 0.394221 7.13427 0.526649 7.00184C0.659076 6.86941 0.838686 6.79502 1.02597 6.79502L16.2692 6.80631L10.895 1.42081C10.8257 1.35609 10.7701 1.27808 10.7316 1.19143C10.6931 1.10477 10.6724 1.01125 10.6708 0.916432C10.6693 0.821618 10.6868 0.727456 10.7224 0.639563C10.758 0.551671 10.8109 0.471848 10.878 0.404858C10.9452 0.337867 11.0251 0.285081 11.113 0.24965C11.201 0.214218 11.2952 0.196864 11.39 0.198625C11.4848 0.200387 11.5783 0.221228 11.6649 0.259903C11.7515 0.298579 11.8294 0.354296 11.894 0.423733L18.4733 7.01439C18.6055 7.14679 18.6798 7.32627 18.6798 7.51339C18.6798 7.70052 18.6055 7.88 18.4733 8.0124L11.894 14.6031C11.7608 14.7318 11.5825 14.803 11.3973 14.8015C11.2122 14.8 11.0351 14.7258 10.9041 14.5949C10.7731 14.4641 10.6987 14.287 10.697 14.1018C10.6953 13.9167 10.7664 13.7383 10.895 13.605L16.2711 8.21859L1.02597 8.20824C0.933155 8.20824 0.841254 8.18994 0.75552 8.1544C0.669785 8.11885 0.591899 8.06675 0.526315 8.00108C0.460732 7.93541 0.408737 7.85746 0.373306 7.77167C0.337874 7.68589 0.319701 7.59397 0.319825 7.50116Z" fill="#222222"/> 
            </svg>
            </button>
        `,
    });
    // Testimonials
    $('.testimonials-section .testimonial-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        prevArrow: `
            <button type="button" class="slick-prev slick-arrow" aria-label="Previous">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18 8.00099C18 7.81738 17.9271 7.64129 17.7972 7.51146C17.6674 7.38163 17.4913 7.30869 17.3077 7.30869L2.36335 7.31977L7.63218 2.03986C7.70014 1.97642 7.75462 1.89994 7.79237 1.81498C7.83013 1.73002 7.85039 1.63833 7.85194 1.54538C7.85349 1.45242 7.83631 1.36011 7.80141 1.27394C7.76651 1.18777 7.71461 1.10951 7.64881 1.04383C7.58301 0.978158 7.50465 0.926406 7.41842 0.891669C7.33218 0.856931 7.23983 0.839918 7.14688 0.841645C7.05393 0.843372 6.96228 0.863805 6.87739 0.901722C6.79251 0.939639 6.71613 0.994264 6.65281 1.06234L0.202463 7.52377C0.0728188 7.65357 0 7.82953 0 8.01299C0 8.19645 0.0728188 8.3724 0.202463 8.50221L6.65281 14.9636C6.78332 15.0898 6.95816 15.1597 7.13968 15.1582C7.3212 15.1567 7.49487 15.084 7.62329 14.9557C7.75171 14.8274 7.8246 14.6538 7.82626 14.4722C7.82792 14.2907 7.75823 14.1158 7.63218 13.9852L2.3615 8.70436L17.3077 8.69421C17.3987 8.69421 17.4888 8.67627 17.5728 8.64142C17.6569 8.60657 17.7333 8.5555 17.7976 8.49111C17.8619 8.42673 17.9128 8.3503 17.9476 8.2662C17.9823 8.1821 18.0001 8.09198 18 8.00099Z" fill="#222222"/>
            </svg>
            </button>
        `,
        nextArrow: `
            <button type="button" class="slick-next slick-arrow" aria-label="Next">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.09501e-07 8.00099C3.01653e-07 7.81738 0.0729383 7.64129 0.202769 7.51146C0.3326 7.38163 0.508688 7.30869 0.692296 7.30869L15.6367 7.31977L10.3678 2.03986C10.2999 1.97642 10.2454 1.89994 10.2076 1.81498C10.1699 1.73002 10.1496 1.63833 10.1481 1.54538C10.1465 1.45242 10.1637 1.36011 10.1986 1.27394C10.2335 1.18777 10.2854 1.10951 10.3512 1.04383C10.417 0.978158 10.4953 0.926406 10.5816 0.891669C10.6678 0.856931 10.7602 0.839918 10.8531 0.841645C10.9461 0.843372 11.0377 0.863805 11.1226 0.901722C11.2075 0.939639 11.2839 0.994264 11.3472 1.06234L17.7975 7.52377C17.9272 7.65357 18 7.82953 18 8.01299C18 8.19645 17.9272 8.3724 17.7975 8.50221L11.3472 14.9636C11.2167 15.0898 11.0418 15.1597 10.8603 15.1582C10.6788 15.1567 10.5051 15.084 10.3767 14.9557C10.2483 14.8274 10.1754 14.6538 10.1737 14.4722C10.1721 14.2907 10.2418 14.1158 10.3678 13.9852L15.6385 8.70436L0.692296 8.69421C0.601305 8.69421 0.511206 8.67627 0.427152 8.64142C0.343099 8.60657 0.26674 8.5555 0.202442 8.49111C0.138145 8.42673 0.0871697 8.3503 0.0524329 8.2662C0.0176961 8.1821 -0.000121008 8.09198 3.09501e-07 8.00099Z" fill="#222222"/>
            </svg>
            </button>
        `,
    });
    // Faqs
    let title = document.querySelectorAll(".faqs-wrapper .faq-item .title-block");
    
    title.forEach((qsitem) => {
        qsitem.addEventListener("click", function (e) {
            let sibling = qsitem.nextElementSibling;
            title.forEach((item) => {
                (item.nextElementSibling.style.height = "0px"), item != qsitem && item.parentNode.classList.remove("active");
            }),
                this.parentNode.classList.toggle("active"),
                qsitem.parentNode.classList.contains("active") ? (sibling.style.height = sibling.scrollHeight + "px") : (sibling.style.height = "0px");
        });
    });
    // Product Faqs
    let title_product = document.querySelectorAll(".product-faq-section .faq-question");
    
    title_product.forEach((qsitem) => {
        qsitem.addEventListener("click", function (e) {
            let sibling = qsitem.nextElementSibling;
            title_product.forEach((item) => {
                (item.nextElementSibling.style.height = "0px"), item != qsitem && item.parentNode.classList.remove("active");
            }),
                this.parentNode.classList.toggle("active"),
                qsitem.parentNode.classList.contains("active") ? (sibling.style.height = sibling.scrollHeight + "px") : (sibling.style.height = "0px");
        });
    });
    // Product Accordion
    let ac_titles = document.querySelectorAll(".product-accordion .accordion-item .title-block");
    if (
        (ac_titles.forEach((qsitem) => {
            qsitem.addEventListener("click", function () {
                let sibling = qsitem.nextElementSibling;
                if (qsitem.parentNode.classList.contains("active")) {
                    qsitem.parentNode.classList.remove("active"), sibling && (sibling.style.height = "0px");
                    return;
                }
                ac_titles.forEach((item) => {
                    let sib = item.nextElementSibling;
                    item.parentNode.classList.remove("active"), sib && (sib.style.height = "0px");
                }),
                    qsitem.parentNode.classList.add("active"),
                    sibling && (sibling.style.height = sibling.scrollHeight + "px");
            });
        }),
        ac_titles.length > 0)
    ) {
        let firstItem = ac_titles[0],
            firstSibling = firstItem.nextElementSibling;
        firstItem.parentNode.classList.add("active"),
            firstSibling && (firstSibling.style.height = firstSibling.scrollHeight + "px");
    }

    // Product Text Rotator
    $('.product-rotation-text .slider').slick({
        infinite: true,
        variableWidth: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 15000,
        cssEase: 'linear',
        arrows: false,
        dots: false
    });
    $('.announcment-bar .for-mobile .announcment-text').slick({
        infinite: true,
        variableWidth: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 15000,
        cssEase: 'linear',
        arrows: false,
        dots: false
    });

    function handleSliders() {
        const $mainSlider = $('.announcment-bar .announcment-text');
        const $productOptions = $('.product-options ul');

        if ($(window).width() < 990) {
            if (!$productOptions.hasClass('slick-initialized')) {
                $productOptions.slick({
                    infinite: true,
                    variableWidth: true,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 0,
                    speed: 5000,
                    cssEase: 'linear',
                    arrows: false,
                    dots: false
                });
            }
        } else {
            if ($productOptions.hasClass('slick-initialized')) {
                $productOptions.slick('unslick');
            }
        }
    }

    // Run on load
    handleSliders();

    // Run on resize
    $(window).on('resize', function () {
        handleSliders();
    });

});